import "./App.css";

import React, { useEffect } from "react";
import TitleSimulator from "./ComponentsSimulator/Formular/TitleSimulator/TitleSimulator";
import InstructionBox from "./ComponentsSimulator/Formular/InstructionBox/InstructionBox";
import FormManager from "./ComponentsSimulator/Formular/FormManager/FormManager";
import Separador from "./ComponentsSimulator/Formular/Separador/Separador";
import FormSecondary from "./ComponentsSimulator/Formular/FormSecondary/FormSecondary";
import FormProponente from "./ComponentsSimulator/Formular/FormProponente/FormProponente";
import FormImovel from "./ComponentsSimulator/Formular/FormImovel/FormImovel";
import FormFinancingBank from "./ComponentsSimulator/Formular/FormFinancingBank/FormFinancingBank";
import Buttons from "./ComponentsSimulator/Formular/Buttons/Buttons";
import Footer from "./ComponentsSimulator/Formular/Footer/Footer";
import Simulation from "./ComponentsSimulator/Formular/Simulation/Simulation";
import Header from "./ComponentsSimulator/Formular/Header/Header";
import useStore from "./ComponentsSimulator/Zustand/Zustand";
import SelectBankType from "./ComponentsSimulator/Formular/SelectBankType/SelectBankType";
import ZustandSelectBankType from "./ComponentsSimulator/Zustand/ZustandSelectBankType";
import SelectCgiOrFin from "./ComponentsSimulator/Formular/SelectCgiOrFin/SelectCgiOrFin";
import Alert from "react-bootstrap/Alert";
import ZustandAlert from "./ComponentsSimulator/Zustand/ZustandAlert";

function App() {
  const simulacoes = useStore((state) => state.simulacoes);
  const loading = useStore((state) => state.loading);
  const setLoading = useStore((state) => state.setLoading);

  let customImage = "./assets/gif.gif";

  const { selectInter } = ZustandSelectBankType();
  const { success, invalid, simulated } = ZustandAlert();

  useEffect(() => {
    setLoading(true);

    setTimeout(() => {
      setLoading(false);
    }, 1);
  }, [setLoading]);

  return (
    <div className="App">
      {loading && (
        <div className="fullscreen-spinner">
          <img
            src={customImage}
            alt="Carregando..."
            className="my-custom-spinner"
            style={{ width: "80px", height: "80px" }}
            E
          />
        </div>
      )}
      <Header />

      <main className="text-start mx-sm-0 mx-md-5 my-2">
        <TitleSimulator />
        <InstructionBox color="#555af8" />
        <FormManager />
        <Separador />
        <FormSecondary />
        {selectInter === "Multibancos" ? (
          <div>
            <Separador />
            <FormProponente />
          </div>
        ) : null}
        <Separador />
        <SelectCgiOrFin />
        <Separador />
        <SelectBankType />
        <Separador />
        <FormImovel />
        <Separador />
        <FormFinancingBank color="#555af8" />
        <Buttons color="#555af8" />
        {simulacoes.length > 0 && (
          <>
            <Separador />
            <Simulation color="#555af8" />
          </>
        )}
      </main>
      <Footer />
      {success ? (
        <Alert key="success" variant="success" className="fixed-alert">
          Proposta enviada para o sistema
        </Alert>
      ) : null}

      {invalid ? (
        <Alert key="danger" variant="danger" className="fixed-alert">
          Por favor, preencha todos os campos corretamente.
        </Alert>
      ) : null}
    </div>
  );
}

export default App;
